module.exports = __webpack_public_path__ + "img/chris-dineff.78a64738.jpg";